var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./test.vue?vue&type=custom&index=0&blockType=html&lang=en"
if (typeof block0 === 'function') block0(component)

export default component.exports